// The GBIF Backbone Taxonomy as ChecklistBank publishes it - same ids as
// GBIF's own keys (gbifKey d7dddbf4-2cf0-4f39-9b2a-bb099caae36c).
const BACKBONE_DATASET = 53147;

/**
 * A species' entry in the GBIF Backbone - the checklist this forum's
 * gbif_ids come from - for curators checking its status, synonyms or
 * parent. Not www.gbif.org/species/{id}: since GBIF switched its site to
 * the Catalogue of Life eXtended Release, that page redirects to the COL
 * XR taxon instead (see https://data-blog.gbif.org/post/catalogue-of-life-taxonomic-backbone/),
 * and GBIF has no page for the Backbone entry itself anymore.
 */
export default function gbifBackboneUrl(gbifId) {
  return `https://www.checklistbank.org/dataset/${BACKBONE_DATASET}/taxon/${gbifId}`;
}
flarum.reg.add('champis-species', 'common/utils/gbifBackboneUrl', gbifBackboneUrl);